import envVar from '../config/envVars';
import httpPost from './httpClient/httpPost';
import httpGet from './httpClient/httpGet';

const generateConsolidatedReport = async (
  academicYear: string,
  grade: string,
  division: string,
  termIds: string[],
  school: string,
  userId: string
): Promise<any> => {
  const url = `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/reports/consolidated-marks`;
  const body = { academicYear, grade, division, termIds, userId };
  return httpPost(url, body, {
    headers: {
      Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
    }
  });
};

const getConsolidatedMarksReport = async (
  academicYear: string,
  grade: string,
  division: string,
  school: string
): Promise<any> => {
  const url = `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/ay/${academicYear}/grade/${grade}/division/${division}/reports/consolidated-marks?isDetailedReport=true`;
  return httpGet(url, {
    headers: {
      Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
    }
  });
};

const generateReportCard = async (
  studentId: string,
  academicYear: string,
  reportCardDate: string
): Promise<any> => {
  const url = `${envVar.REACT_APP_EXAM_BASE_URL}/students/${studentId}/academic-year/${academicYear}/report-card?reportCardDate=${reportCardDate}`;
  return httpGet(url, {
    headers: {
      Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
    }
  });
};

const consolidatedMarksApis = {
  generateConsolidatedReport,
  getConsolidatedMarksReport,
  generateReportCard
};

export default consolidatedMarksApis;
